'use strict';

module.exports = /*@ngInject*/
function() {
    return function(input) {
        if (input !== undefined) {
            return window.encodeURIComponent(input) // encode input
                .replace(/%20/g, '+') // replace encoded spaces
                .replace(/%E9|e9|%C3%A9/g, 'e') // replace encoded accented e
                .replace(/%26|%2C/g, ''); // replace & and ,
        }
    };
};
